import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';

import { RequestType } from '../../../types/enums/request-enums';
//#region comment metod
const CompanyList = () =>
    request({
        url: ApiURL.Query.CompanyList,
        method: RequestType.GET,
    });

const GetSelectedItemList = (data: any): Promise<any> =>
    request({
        url: ApiURL.Query.GetSelectedItemList,
        method: RequestType.POST,
        data,
    });
const GetShippingCompanyLabel = (data: any): Promise<any> =>
    request({
        url: ApiURL.Query.GetShippingCompanyLabel,
        method: RequestType.POST,
        data,
    });

const CargoQuery = {
    CompanyList,
    GetSelectedItemList,
    GetShippingCompanyLabel,
};

export default CargoQuery;
